<template>
  <PageLayout title="周易八卦">

    <!-- ===================== 移动端模板 ===================== -->
    <div v-if="isMobile" class="mobile-iching">
      <!-- 输入区域 -->
      <div class="mobile-input-card">
        <div class="mobile-input-header">
          <span class="mobile-input-icon">☯️</span>
          <span class="mobile-input-title">AI 易经</span>
        </div>
        <textarea
          v-model="queryContent"
          placeholder="请输入您想问询的事项..."
          rows="3"
          class="mobile-input-textarea"
        ></textarea>
        <button
          class="mobile-start-btn"
          :disabled="!queryContent.trim() || yaos.length > 0"
          @click="throwNextYao"
        >
          🔮 开始起卦
        </button>
      </div>

      <!-- 投币+爻象区（上下布局） -->
      <div v-if="yaos.length > 0 || isFlipping" class="mobile-casting-card">
        <div class="mobile-section-title">🪙 投掷硬币</div>

        <!-- 爻象显示 -->
        <div class="mobile-yao-display">
          <div v-for="(_, index) in 6" :key="index"
               class="mobile-yao-row"
               :class="{ 'mobile-yao-current': (5 - index) === yaos.length }">
            <span class="mobile-yao-position">{{ YAO_POSITIONS[5 - index] }}</span>
            <span class="mobile-yao-symbol">{{ yaos[5 - index] ? getMobileYaoSymbol(yaos[5 - index]) : '━━━━' }}</span>
            <span class="mobile-yao-type">{{ formatYaoType(yaos[5 - index]) }}</span>
          </div>
        </div>

        <!-- 投币按钮 -->
        <button
          class="mobile-throw-btn"
          :disabled="isFlipping || isComplete"
          @click="throwNextYao"
        >
          <span v-if="isFlipping" class="mobile-throw-btn-loading">🪙 投掷中...</span>
          <span v-else>{{ isComplete ? '✅ 卦象已成' : '🪙 投掷硬币' }}</span>
        </button>
      </div>

      <!-- 解读区域（折叠面板） -->
      <div v-if="hexagram" class="mobile-interpretation-card">
        <div class="mobile-section-title">🔮 卦象解读</div>

        <!-- 卦名折叠（默认展开） -->
        <div class="mobile-accordion">
          <div class="mobile-accordion-header" @click="mobileAccordion.hexagramName = !mobileAccordion.hexagramName">
            <span class="mobile-accordion-label">卦名：{{ hexagram.symbol }} {{ hexagram.name }}卦</span>
            <span class="mobile-accordion-arrow" :class="{ 'expanded': mobileAccordion.hexagramName }">▸</span>
          </div>
          <div v-show="mobileAccordion.hexagramName" class="mobile-accordion-body">
            <div class="mobile-hexagram-alias" v-if="hexagram.alias">{{ hexagram.alias }}</div>
            <div class="mobile-hexagram-meaning" v-html="hexagram.meaning ? marked(hexagram.meaning) : ''"></div>
          </div>
        </div>

        <!-- AI智能解读（默认展开） -->
        <div class="mobile-accordion">
          <div class="mobile-accordion-header" @click="mobileAccordion.aiInterpretation = !mobileAccordion.aiInterpretation">
            <span class="mobile-accordion-label">AI 智能解读</span>
            <span class="mobile-accordion-arrow" :class="{ 'expanded': mobileAccordion.aiInterpretation }">▸</span>
          </div>
          <div v-show="mobileAccordion.aiInterpretation" class="mobile-accordion-body">
            <div v-if="isLoading" class="mobile-loading">
              <div class="mobile-loading-spinner"></div>
              <span>正在解读卦象...</span>
              <span class="mobile-loading-fun-msg">{{ currentLoadingMsg }}</span>
            </div>
            <div v-else-if="interpretation" class="mobile-ai-response" v-html="markedInterpretation"></div>
            <div v-else class="mobile-empty">暂无解读结果</div>
          </div>
        </div>

        <!-- 变卦启示（默认折叠） -->
        <div v-if="changedHexagram" class="mobile-accordion">
          <div class="mobile-accordion-header" @click="mobileAccordion.changedGua = !mobileAccordion.changedGua">
            <span class="mobile-accordion-label">变卦启示</span>
            <span class="mobile-accordion-arrow" :class="{ 'expanded': mobileAccordion.changedGua }">▸</span>
          </div>
          <div v-show="mobileAccordion.changedGua" class="mobile-accordion-body">
            <div class="mobile-change-info">
              <span>从 {{ hexagram.name }}卦 → {{ changedHexagram.name }}卦</span>
            </div>
            <div class="mobile-changed-meaning" v-html="changedHexagram.meaning ? marked(changedHexagram.meaning) : ''"></div>
          </div>
        </div>

        <!-- 六爻详解（默认折叠） -->
        <div v-if="hexagram.yaoTexts && hexagram.yaoTexts.length" class="mobile-accordion">
          <div class="mobile-accordion-header" @click="mobileAccordion.yaoDetail = !mobileAccordion.yaoDetail">
            <span class="mobile-accordion-label">六爻详解</span>
            <span class="mobile-accordion-arrow" :class="{ 'expanded': mobileAccordion.yaoDetail }">▸</span>
          </div>
          <div v-show="mobileAccordion.yaoDetail" class="mobile-accordion-body">
            <div v-for="(text, position) in hexagram.yaoTexts"
                 :key="position"
                 class="mobile-yao-text-item"
                 :class="{ 'mobile-yao-text-changing': isChangingPosition(position) }">
              <div class="mobile-yao-text-header">
                <span class="mobile-yao-text-position">{{ getYaoPrefix(position - 1, yaos[position - 1]) }}</span>
                <span v-if="isChangingPosition(position - 1)" class="mobile-yao-text-changing-mark">变</span>
              </div>
              <div class="mobile-yao-text-content" v-html="text ? marked(text) : ''"></div>
            </div>
          </div>
        </div>

        <div class="mobile-share-row" style="padding:2px 16px 4px">
          <button class="mobile-start-btn" @click="shareVisible = true">
            📣 分享我的卦象
          </button>
        </div>
      </div>
    </div>

    <!-- ===================== PC端模板（保持原样） ===================== -->
    <template v-else>
      <!-- 问询输入区域 -->
      <MysticalCard class="query-section">
        <h3 class="section-title">请输入您想问询的事项</h3>
        <div class="query-input">
          <textarea 
            v-model="queryContent"
            placeholder="例如：我目前的事业发展方向是否正确？"
            rows="4"
            class="mystical-textarea"
          ></textarea>
        </div>
      </MysticalCard>

      <!-- 卦象生成区域 -->
      <div class="casting-area">
        <!-- 左侧：爻象显示 -->
        <div class="yao-display">
          <div v-for="(_, index) in 6" :key="index" 
               class="yao-row" 
               :class="getCurrentYaoClass(index)">
            <!-- 爻位 -->
            <span class="yao-position" :style="{ width: '15%' }">
              {{ YAO_POSITIONS[5 - index] }}
            </span>
            
            <!-- 爻符号 -->
            <span class="yao-symbol" :style="{ width: '25%', textAlign: 'center' }">
              {{ yaos[5 - index] ? YAO_SYMBOLS[yaos[5 - index]] : '━━━━' }}
            </span>
            
            <!-- 爻类型 -->
            <span class="yao-type" :style="{ width: '20%', textAlign: 'center' }">
              {{ formatYaoType(yaos[5 - index]) }}
            </span>
            
            <!-- 硬币结果 -->
            <div class="coin-results" :style="{ width: '40%', justifyContent: 'flex-end' }">
              <span v-for="(result, i) in getCoinResultsForYao(5 - index)" 
                    :key="i" 
                    class="coin-result"
                    :class="{ 'front': result, 'back': !result }">
                {{ result ? '正' : '反' }}
              </span>
            </div>
          </div>
        </div>

        <!-- 右侧：硬币区域 -->
        <div class="coin-area">
          <div class="coins-container">
            <div v-for="(coin, index) in 3" :key="index" 
                 class="coin" :class="{ 'flipping': isFlipping }">
              <div class="coin-inner" :style="getCoinStyle(index)">
                <div class="coin-front">
                  <img :src="`/coins/${coinStyle}/front.png`" alt="正面">
                </div>
                <div class="coin-back">
                  <img :src="`/coins/${coinStyle}/back.png`" alt="反面">
                </div>
              </div>
            </div>
          </div>

          <div class="casting-controls">
            <p class="current-yao">正在生成：{{ currentYaoName }}</p>
            <MysticalButton 
              @click="throwNextYao"
              :disabled="isFlipping || !queryContent || isComplete"
              class="throw-button"
            >
              {{ isComplete ? '卦象已成' : '投掷硬币' }}
            </MysticalButton>
          </div>
        </div>
      </div>

      <!-- 卦象解读区域 -->
      <div class="interpretation-container">
        <div v-if="hexagram" class="interpretation-section">
          <div style="text-align:center;margin-bottom:14px">
            <MysticalButton @click="shareVisible = true">📣 分享我的卦象</MysticalButton>
          </div>
          <!-- 卦象基本信息 -->
          <div class="hexagram-info">
            <div class="hexagram-title">
              <h2>{{ hexagram.symbol }} {{ hexagram.name }}卦 {{ hexagram.alias }}</h2>
            </div>
            <div class="diagram-container">
              <HexagramDiagram 
                v-if="hexagram && hexagram.name"
                :yaos="yaos"
                :changed-yaos="changedYaos"
                :hexagram="hexagram"
                :changed-hexagram="changedHexagram"
              />
            </div>
          </div>

          <!-- 解读内容区域 -->
          <div class="interpretation-content">
            <!-- 传统易经解读 -->
            <MysticalCard class="interpretation-card">
              <template #title>
                <div class="card-header">
                  <h3>卦象总论</h3>
                  <p class="subtitle">基于经典易经理论的解读</p>
                </div>
              </template>
              
              <!-- 卦辞部分 -->
              <div class="section">
                <h4 class="section-title">本卦象征</h4>
                <div class="content" v-html="hexagram.meaning ? marked(hexagram.meaning) : ''"></div>
              </div>

              <!-- 变卦部分 -->
              <div v-if="changedHexagram" class="section">
                <h4 class="section-title">变卦启示</h4>
                <div class="content">
                  <div class="change-info">
                    <span class="from-to">从 {{ hexagram.name }}卦 变至 {{ changedHexagram.name }}卦</span>
                    <span class="trigrams">{{ hexagram.upperTrigram?.name }}{{ hexagram.lowerTrigram?.name }} → 
                      {{ changedHexagram.upperTrigram?.name }}{{ changedHexagram.lowerTrigram?.name }}</span>
                  </div>
                  <div v-html="changedHexagram.meaning ? marked(changedHexagram.meaning) : ''"></div>
                </div>
              </div>

              <!-- 六爻解读 -->
              <div class="section">
                <h4 class="section-title">六爻详解</h4>
                <div class="yao-texts">
                  <div v-for="(text, position) in hexagram.yaoTexts" 
                       :key="position"
                       class="yao-text"
                       :class="{ 'changing': isChangingPosition(position) }">
                    <div class="yao-header">
                      <span class="position">{{ getYaoPrefix(position - 1, yaos[position - 1]) }}</span>
                      <span v-if="isChangingPosition(position - 1)" class="changing-mark">变</span>
                    </div>
                    <div class="content" v-html="text ? marked(text) : ''"></div>
                  </div>
                </div>
              </div>
            </MysticalCard>

            <!-- 现代解读视角 -->
            <div class="modern-interpretation">
              <div v-if="isLoading" class="loading-container">
                <div class="mystical-loading">
                  <div class="loading-circle"></div>
                  <div class="loading-text">正在解读卦象...</div>
                  <div class="loading-fun-msg">{{ currentLoadingMsg }}</div>
                </div>
              </div>
              <div v-else-if="interpretation" v-html="markedInterpretation" class="ai-response"></div>
              <div v-else class="no-interpretation">暂无解读结果</div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <PayDialog
      v-model:visible="showPayDialog"
      :cost="payDialogCost"
      :balance="payDialogBalance"
      :feature="payDialogFeature"
      :rmb-price="payDialogRmbPrice"
      @goPoints="goToPoints"
    />
  <GuaShareCard
      v-if="guaShareProps"
      v-model:visible="shareVisible"
      :mode="guaShareProps.mode"
      :gua="guaShareProps.gua"
      :bian-gua="guaShareProps.bianGua"
      :changing="guaShareProps.changing"
      :yao-name="guaShareProps.yaoName"
      :yao-ci="guaShareProps.yaoCi"
      page="iching" />
  </PageLayout>
</template>

<script setup>
import { ref, computed, onMounted, shallowRef, onUnmounted } from 'vue'
import { useMobile } from '@/composables/useMobile'
import { useAuthGuard } from '@/composables/useAuthGuard'
import PayDialog from '@/components/common/PayDialog.vue'
import { usePaymentGuard } from '@/composables/usePaymentGuard'
import PageLayout from '@/components/layout/PageLayout.vue'
import { GuaShareCard } from '@/components/share'
import MysticalCard from '@/components/common/MysticalCard.vue'
import MysticalButton from '@/components/common/MysticalButton.vue'
import HexagramDiagram from '@/components/iching/HexagramDiagram.vue'
import { YAO_TYPES, YAO_POSITIONS, YAO_SYMBOLS, isChangingYao } from '@/constants/iching'
import { getHexagramInfo, HEXAGRAMS } from '@/constants/64gua'
import { interpretHexagram } from '@/api/iching'
import { marked } from 'marked'
import { API_CONFIG } from '@/config'
import { getLoadingMessages } from '@/data/loadingMessages'
// import AI_CONFIG from '@/config/ai.config' // 已迁移到后端
import { ElMessage } from 'element-plus'

// 记录交互的辅助函数
const { requireLogin } = useAuthGuard()
const { showPayDialog, payDialogCost, payDialogBalance, payDialogFeature, payDialogRmbPrice, checkFeatureCost, goToPoints } = usePaymentGuard()

const logInteraction = async (type, question, result, interpretation) => {
  try {
    const token = localStorage.getItem('token')
    if (!token) return // 未登录不记录

    await fetch(`${API_CONFIG.baseUrl}${API_CONFIG.endpoints.persona.interaction}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        type,
        question,
        result,
        interpretation
      })
    })
  } catch (error) {
    // 静默失败，不影响用户体验
    console.error('记录交互失败:', error)
  }
}

// 修改查找卦象的辅助函数
const findHexagram = (yaos) => {
  // 从下到上的生成顺序需要反转为从上到下的查询顺序
  const binaryString = [...yaos].reverse().map(yao => {
    return yao === YAO_TYPES.YOUNG_YANG || yao === YAO_TYPES.OLD_YANG ? '1' : '0'
  }).join('')
  
  const hexagramInfo = Object.values(HEXAGRAMS).find(hex => hex.binary === binaryString)
  if (!hexagramInfo) {
    throw new Error('未找到对应卦象')
  }
  return hexagramInfo
}

// 修改计算变卦的辅助函数
const calculateChangedHexagram = (yaos) => {
  const changedYaos = yaos.map((yao, index) => ({
    position: index,
    type: yao,
    isChanging: isChangingYao(yao)
  })).filter(yao => yao.isChanging)

  if (changedYaos.length === 0) return null

  // 计算变卦的爻
  const changedYaosList = yaos.map((yao, index) => {
    const isChanging = changedYaos.some(changed => changed.position === index)
    if (!isChanging) return yao
    // 老阳变少阴，老阴变少阳
    return yao === YAO_TYPES.OLD_YANG ? YAO_TYPES.YOUNG_YIN : YAO_TYPES.YOUNG_YANG
  })

  try {
    const changedHexagramInfo = findHexagram(changedYaosList)
    return {
      hexagram: changedHexagramInfo,
      changedYaos
    }
  } catch (error) {
    console.error('计算变卦失败:', error)
    return null
  }
}

const queryContent = ref('')
const yaos = ref([])

// 移动端检测
const { isMobile } = useMobile()

// 移动端手风琴折叠状态（卦名+AI默认展开，其余折叠）
const mobileAccordion = ref({
  hexagramName: true,
  aiInterpretation: true,
  changedGua: false,
  yaoDetail: false
})

// 移动端爻符号（阳爻粗线 / 阴爻断线）
const getMobileYaoSymbol = (yao) => {
  if (!yao) return '━━━━'
  const isYang = yao === YAO_TYPES.YOUNG_YANG || yao === YAO_TYPES.OLD_YANG
  const isChanging = yao === YAO_TYPES.OLD_YANG || yao === YAO_TYPES.OLD_YIN
  if (isChanging) {
    return isYang ? '━━━○━━━' : '━━━×━━━'
  }
  return isYang ? '━━━━━━━━' : '━━━ ━━━'
}
const isFlipping = ref(false)
const coinStyle = ref('ancient')
const currentYaoIndex = ref(0)
const hexagram = shallowRef(null)
const shareVisible = ref(false)

// 分享卡 props 组装: 无老阳/老阴变爻 → mode='single' 单卦卡; 有变爻 → mode='bian' 变卦卡
// (动爻爻辞主文: 单变爻取本卦 yaoTexts 对应爻去「初九：」前缀; 多爻动 yaoCi 用本卦卦辞兑底、yaoName 用「N爻动」)
const YAO_TEXT_KEYS = ['one', 'two', 'three', 'four', 'five', 'six']   // one=初爻 … six=上爻(自下而上)
const guaShareProps = computed(() => {
  if (!hexagram.value || yaos.value.length !== 6) return null
  try {
    const ben = findHexagram(yaos.value)                  // 完整卦对象(含 binary/title/attributes/yaoTexts; hexagram ref 是裁剪版不可用)
    const changed = calculateChangedHexagram(yaos.value)  // { hexagram: 完整变卦, changedYaos } | null
    const changing = (changed?.changedYaos || []).map(y => y.position)   // 老爻位(自下而上 index 0..5)
    if (!changed || changing.length === 0) {
      return { mode: 'single', gua: ben, bianGua: null, changing: [], yaoName: '', yaoCi: '' }
    }
    if (changing.length === 1) {
      const raw = String(ben.yaoTexts?.[YAO_TEXT_KEYS[changing[0]]] || '')
      const m = raw.match(/^([^：:]+)[：:]\s*(.*)$/)      // 去「初九：」类前缀, 前缀即 yaoName
      return { mode: 'bian', gua: ben, bianGua: changed.hexagram, changing,
               yaoName: (m?.[1] || '').trim(), yaoCi: m?.[2] || ben.meaning }
    }
    return { mode: 'bian', gua: ben, bianGua: changed.hexagram, changing,
             yaoName: `${changing.length}爻动`, yaoCi: ben.meaning }
  } catch (e) {
    console.error('[IChingView] 组装分享卡 props 失败', e)
    return null
  }
})
const changedHexagram = shallowRef(null)
const changedYaos = ref([])
const interpretation = ref('')
const coinResults = ref([true, true, true]) // 默认都是正面

// 存储每个爻的硬币结果
const yaoCoinsHistory = ref([])

const currentYaoName = computed(() => {
  return YAO_POSITIONS[currentYaoIndex.value] || ''
})

const isComplete = computed(() => {
  return yaos.value.length === 6
})

// 获取硬币显示样式
const getCoinStyle = (index) => {
  if (isFlipping.value) return {}
  return {
    transform: `rotateY(${coinResults.value[index] ? 0 : 180}deg)`
  }
}

// 修改投掷函数
const throwNextYao = async () => {
  if (isFlipping.value || !queryContent.value || isComplete.value) return
  
  try {
    isFlipping.value = true
    
    // 模拟投掷动画
    await new Promise(resolve => setTimeout(resolve, 2000))
    
    // 生成当前爻的结果
    const result = throwCoins()
    
    // 确保不会重复添加
    if (yaos.value.length < 6) {
      yaos.value.push(result)
      // 记录硬币结果
      yaoCoinsHistory.value.push([...coinResults.value])
      // 更新当前爻位索引
      currentYaoIndex.value = yaos.value.length
    }
    
    // 如果六爻已满,生成卦象
    if (yaos.value.length === 6) {
      await generateHexagram()
    }
    
  } catch (error) {
    console.error('投掷失败:', error)
    ElMessage.error('投掷过程出现错误')
  } finally {
    isFlipping.value = false
  }
}

// 修改投掷硬币函数
const throwCoins = () => {
  // 生成三个随机布尔值，true表示正面，false表示反面
  coinResults.value = Array.from({ length: 3 }, () => Math.random() > 0.5)
  
  // 统计正面数量
  const sum = coinResults.value.filter(r => r).length
  
  // 根据正面数量确定爻的类型
  switch (sum) {
    case 3: return YAO_TYPES.OLD_YANG    // 三正为老阳 (○)
    case 2: return YAO_TYPES.YOUNG_YANG  // 两正一反为少阳 (─)
    case 1: return YAO_TYPES.YOUNG_YIN   // 一正两反为少阴 (──)
    case 0: return YAO_TYPES.OLD_YIN     // 三反为老阴 (×)
    default: return YAO_TYPES.YOUNG_YANG // 默认返回少阳
  }
}

const isLoading = ref(false)

// 加载文案轮播
const loadingMsgs = ref([])
const currentLoadingMsg = ref('')
let loadingMsgTimer = null
function startLoadingMessages() {
  loadingMsgs.value = getLoadingMessages('iching', 8)
  currentLoadingMsg.value = loadingMsgs.value[0]
  let idx = 0
  loadingMsgTimer = setInterval(() => {
    idx = (idx + 1) % loadingMsgs.value.length
    currentLoadingMsg.value = loadingMsgs.value[idx]
  }, 2500)
}
function stopLoadingMessages() {
  if (loadingMsgTimer) { clearInterval(loadingMsgTimer); loadingMsgTimer = null }
}

// 修改生成卦象函数
const generateHexagram = async () => {
  if (!requireLogin('iching-ai')) return
  try {
    // 积分守卫：动态查价（feature-cost，含会员折扣/免费额度），查价失败放行由后端扣费兜底
    const canProceed = await checkFeatureCost('iching', '周易解卦')
    if (!canProceed) return

    isLoading.value = true
    interpretation.value = ''
    startLoadingMessages()
    
    // 获取本卦信息
    const currentHexagram = findHexagram(yaos.value)
    if (!currentHexagram) {
      throw new Error('无法找到对应卦象')
    }

    // 确保卦象信息完整
    const hexagramInfo = {
      name: currentHexagram.name,
      symbol: currentHexagram.symbol,
      meaning: currentHexagram.meaning || '暂无卦辞',
      description: currentHexagram.description || '',
      upperTrigram: currentHexagram.upperTrigram || {},
      lowerTrigram: currentHexagram.lowerTrigram || {},
      yaoTexts: currentHexagram.yaoTexts || []
    }
    
    hexagram.value = hexagramInfo

    // 计算变卦
    const changed = calculateChangedHexagram(yaos.value)
    let changedHexagramInfo = null
    
    if (changed?.hexagram) {
      changedHexagramInfo = {
        name: changed.hexagram.name,
        symbol: changed.hexagram.symbol,
        meaning: changed.hexagram.meaning || '暂无卦辞',
        yaoTexts: changed.hexagram.yaoTexts || []
      }
      changedHexagram.value = changedHexagramInfo
      changedYaos.value = changed.changedYaos
    } else {
      changedHexagram.value = null
      changedYaos.value = []
    }

    // 准备解卦参数(changingYaos: 1=初爻…6=上爻, 自下而上; yaoStates: 各爻老少阴阳)
    const params = {
      hexagram: hexagramInfo,
      question: queryContent.value,
      changedHexagram: changedHexagramInfo,
      changingYaos: changed?.changedYaos?.map(c => c.position + 1) || [],
      yaoStates: yaos.value
    }


    // 调用 AI 解读
    const result = await interpretHexagram(params)
    
    if (result?.result) {
      interpretation.value = result.result
    }

    // 记录交互
    await logInteraction('iching', queryContent.value, {
      hexagram: hexagramInfo.name,
      symbol: hexagramInfo.symbol,
      yaos: yaos.value,
      changedHexagram: changedHexagramInfo ? changedHexagramInfo.name : null
    }, interpretation.value)

  } catch (error) {
    console.error('解卦失败:', error)
    if (error.message && error.message.includes('积分不足')) return
    ElMessage.error(error.message || '解卦过程中出现错误，但您仍可以查看卦象基本信息。')
  } finally {
    isLoading.value = false
    stopLoadingMessages()
  }
}

// 获取指定爻的硬币结果
const getCoinResultsForYao = (yaoIndex) => {
  return yaoCoinsHistory.value[yaoIndex] || []
}

// 重置功能
const reset = () => {
  yaos.value = []
  yaoCoinsHistory.value = []
  hexagram.value = null
  changedHexagram.value = null
  changedYaos.value = []
  interpretation.value = ''
  currentYaoIndex.value = 0
  coinResults.value = [true, true, true]
}

// 修改当前爻高亮显示的样式
const getCurrentYaoClass = (index) => {
  const currentIndex = 5 - index
  if (currentIndex === yaos.value.length) {
    return 'current'
  }
  return ''
}



// 判断是否为变爻位置
const isChangingPosition = (position) => {
  return changedYaos.value.some(yao => yao.position === position)
}



// 格式化爻类型显示
const formatYaoType = (yao) => {
  if (!yao) return '未生成'
  const types = {
    [YAO_TYPES.YOUNG_YANG]: '少阳',
    [YAO_TYPES.YOUNG_YIN]: '少阴',
    [YAO_TYPES.OLD_YANG]: '老阳',
    [YAO_TYPES.OLD_YIN]: '老阴'
  }
  return types[yao] || yao
}



// 添加 markedInterpretation 计算属性
const markedInterpretation = computed(() => {
  return interpretation.value ? marked(interpretation.value) : ''
})

</script>

<style scoped>

/* 问询区域样式 */
.query-section {
  margin-bottom: var(--spacing-xl);
}

.section-title {
  color: var(--color-accent);
  text-align: center;
  margin-bottom: var(--spacing-lg);
  font-family: var(--font-mystical);
}

.mystical-textarea {
  width: 100%;
  padding: var(--spacing-lg);
  background: rgba(45, 12, 64, 0.1);
  border: 1px solid var(--color-accent);
  border-radius: var(--radius-lg);
  color: var(--color-light);
  font-size: 1rem;
  line-height: 1.6;
  resize: vertical;
  transition: all var(--transition-normal);
}

.mystical-textarea:focus {
  outline: none;
  background: rgba(45, 12, 64, 0.2);
  box-shadow: 0 0 10px var(--color-accent);
}

.casting-area {
  display: grid;
  grid-template-columns: auto 320px;
  gap: var(--spacing-xl);
  margin: var(--spacing-lg) 0;
  min-height: 320px;
}

.yao-display {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  width: 100%;
}

.yao-row {
  display: flex;
  align-items: center;
  padding: var(--spacing-md);
  gap: var(--spacing-md);
  height: 40px;
  background: rgba(var(--color-bg-rgb), 0.1);
  border-radius: var(--radius-md);
  margin-bottom: 4px;
}

.yao-position {
  width: 15%;
  text-align: right;
  padding-right: var(--spacing-sm);
}

.yao-symbol {
  width: 25%;
  text-align: center;
  font-size: 0.95em;
}

.yao-type {
  width: 20%;
  text-align: center;
  font-size: 0.95em;
}

.coin-results {
  width: 40%;
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-sm);
  flex-shrink: 0;
}

.coin-result {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 0.9em;
  font-weight: 500;
}

.coin-result.front {
  background: linear-gradient(45deg, var(--fh-gold), #FFA500);
  color: #000;
}

.coin-result.back {
  background: linear-gradient(45deg, #C0C0C0, #A9A9A9);
  color: var(--fh-text-bright);
}

.coin-area {
  width: 320px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-xl);
}

.casting-controls {
  text-align: center;
}

.current-yao {
  margin-bottom: var(--spacing-md);
  color: var(--color-accent);
}

/* 确保硬币默认显示正面 */
.coin-inner {
  transform: rotateY(0deg);
}

.coin-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-xl);
  padding: var(--spacing-xl) 0;
}

.coins-container {
  display: flex;
  justify-content: center;
  gap: var(--spacing-lg);
  width: 100%;
  height: 120px;
  padding: var(--spacing-md);
}

.coin {
  flex: 0 0 80px;
  width: 80px;
  height: 80px;
}

.coin-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: transform 0.6s ease-in-out;
}

.coin-front,
.coin-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 50%;
  overflow: hidden;
  background: var(--color-bg);
  display: flex;
  align-items: center;
  justify-content: center;
}

.coin-back {
  transform: rotateY(180deg);
}

.coin-front img,
.coin-back img {
  width: 100%;
  height: 100%;
  object-fit: contain;  /* 改为 contain 以保持图比例 */
}

.coin.flipping .coin-inner {
  animation: flip-coin 2s ease-in-out;
}

@keyframes flip-coin {
  0% { 
    transform: rotateY(0) translateY(0);
    animation-timing-function: ease-in;
  }
  20% { 
    transform: rotateY(720deg) translateY(-80px);
    animation-timing-function: ease-out;
  }
  40% { 
    transform: rotateY(1440deg) translateY(0);
    animation-timing-function: ease-in;
  }
  60% { 
    transform: rotateY(2160deg) translateY(-40px);
    animation-timing-function: ease-out;
  }
  80% { 
    transform: rotateY(2880deg) translateY(-20px);
    animation-timing-function: ease-in;
  }
  100% { 
    transform: rotateY(3600deg) translateY(0);
  }
}

/* 硬币样式选择器 */
.coin-style-select {
  display: flex;
  justify-content: center;
  gap: var(--spacing-lg);
  margin-bottom: var(--spacing-xl);
}

/* 添加响应式布局 */

@media (max-width: 768px) {
  .casting-area {
    grid-template-columns: 1fr;
  }

  .coin-area {
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
  }

  .yao-display {
    width: 100%;
    gap: 2px;
  }

  .yao-row {
    height: auto;
    min-height: 38px;
    padding: var(--spacing-sm);
    flex-wrap: wrap;
    margin-bottom: 0;
  }

  .yao-position {
    width: auto;
    flex-shrink: 0;
  }

  .yao-symbol {
    width: auto;
    flex: 1;
    white-space: nowrap;
  }

  .yao-type {
    width: auto;
    flex-shrink: 0;
  }

  .coin-results {
    width: auto;
    flex-shrink: 0;
  }
}

@media (max-width: 480px) {
  .coin {
    flex: 0 0 60px;
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 360px) {
  .hexagram-title h2 {
    font-size: 1rem;
  }

  .section-title {
    font-size: 1rem;
  }

  .yao-symbol {
    font-size: 18px;
    letter-spacing: 2px;
  }

  .yao-position {
    font-size: 0.75rem;
  }

  .yao-type {
    font-size: 0.75rem;
  }

  .coin-result {
    font-size: 0.75rem;
  }

  .current-yao {
    font-size: 0.85rem;
  }

  .mystical-textarea {
    padding: var(--spacing-md);
  }

  .interpretation-section {
    padding: var(--spacing-md);
  }

  .interpretation-card :deep(.card-content) {
    padding: var(--spacing-md);
  }

  .yao-display {
    font-size: 0.85rem;
    gap: 2px;
  }

  .yao-row {
    gap: var(--spacing-sm);
    height: auto;
    min-height: 32px;
    padding: 2px var(--spacing-sm);
    flex-wrap: wrap;
  }
}

.button-container {
  text-align: center;
}

.shake-button {
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
}

.hexagram-display {
  margin-bottom: var(--spacing-xl);
}

.yao-container {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.yao-row {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
}

.yao-position {
  width: 60px;
  text-align: right;
  color: var(--color-text-light);
}

.yao-symbol {
  font-family: monospace;
  font-size: 24px;
  letter-spacing: 4px;
}

.coin-style-select {
  display: flex;
  justify-content: center;
  gap: var(--spacing-lg);
  margin-bottom: var(--spacing-xl);
}

/* 修改爻行高亮样式 */
.yao-row.current {
  background: rgba(var(--color-accent-rgb), 0.1);
  border: 1px solid var(--color-accent);
}

.yao-row.current::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(var(--color-accent-rgb), 0.2),
    transparent
  );
  animation: shine 2s infinite;
}

@keyframes shine {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* 添加硬币结果显示样式 */
.coin-results {
  display: flex;
  gap: var(--spacing-xs);
  margin-left: auto;
  padding-left: var(--spacing-md);
}

.coin-result {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 0.8em;
  font-weight: 500;
}

.coin-result.front {
  background: linear-gradient(45deg, var(--fh-gold), #FFA500);
  color: #000;
}

.coin-result.back {
  background: linear-gradient(45deg, #C0C0C0, #A9A9A9);
  color: var(--fh-text-bright);
}

/* 卦象图形样式 */
.hexagram-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--spacing-xl);
}

.hexagram-diagram {
  display: flex;
  align-items: center;
  gap: var(--spacing-xl);
}

.trigrams {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.upper-trigram,
.lower-trigram {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.yao-line {
  width: 60px;
  height: 4px;
  background: var(--color-accent);
  position: relative;
}

.yao-line.yin {
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 4px;
    height: 100%;
    background: var(--color-bg);
    transform: translateX(-50%);
  }
}

.yao-line.changing {
  animation: pulse 2s infinite;
  &::after {
    content: '○';
    position: absolute;
    right: -24px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--color-accent);
    font-size: 12px;
  }
}

.arrow {
  color: var(--color-accent);
  font-size: 24px;
  margin: 0 var(--spacing-md);
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--color-light);
  z-index: 10;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--color-accent);
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: var(--spacing-md);
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.hexagram-meaning {
  margin: var(--spacing-xl) 0;
  padding: var(--spacing-lg);
  background: rgba(var(--color-accent-rgb), 0.1);
  border-radius: var(--radius-lg);
}

.meaning {
  font-size: 1.2rem;
  color: var(--color-accent);
  margin-bottom: var(--spacing-md);
}

.yao-texts {
  margin: var(--spacing-xl) 0;
}

.yao-text {
  padding: var(--spacing-md);
  border-left: 2px solid transparent;
  transition: all 0.3s ease;
  margin-bottom: var(--spacing-md);
}

.yao-text-header {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-sm);
}

.yao-symbol {
  font-family: monospace;
  font-size: 1.2em;
  color: var(--color-accent);
}

.yao-text-content {
  margin-left: var(--spacing-xl);
  color: var(--color-text);
  line-height: 1.5;
}

.position {
  min-width: 60px;
  color: var(--color-accent);
  font-weight: 500;
}

.coin-results {
  margin-left: auto;
}

.streaming-indicator {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  color: var(--color-accent);
  margin-bottom: var(--spacing-md);
}

.dot-animation::after {
  content: '';
  animation: dots 1.5s steps(4, end) infinite;
}

@keyframes dots {
  0%, 20% { content: ''; }
  40% { content: '.'; }
  60% { content: '..'; }
  80% { content: '...'; }
}

.interpretation-section {
  margin-top: var(--spacing-xl);
  padding: var(--spacing-lg);
  background: rgba(var(--color-accent-rgb), 0.05);
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-accent);
}

.interpretation-title {
  color: var(--color-accent);
  margin-bottom: var(--spacing-lg);
  font-size: 1.2rem;
}

.interpretation-content {
  line-height: 1.6;
  color: var(--color-text);
  white-space: pre-wrap;
}

:deep(.markdown-body) {
  background: transparent;
  color: var(--color-text);
  font-family: var(--font-text);
}

:deep(.markdown-body h1) {
  color: var(--color-accent);
  font-size: 1.8rem;
  margin: 1.5em 0 1em;
  padding-bottom: 0.3em;
  border-bottom: 1px solid var(--color-accent);
}

:deep(.markdown-body h2) {
  color: var(--color-accent);
  font-size: 1.5rem;
  margin: 1.4em 0 0.8em;
}

:deep(.markdown-body h3) {
  color: var(--color-accent);
  font-size: 1.3rem;
  margin: 1.3em 0 0.7em;
}

:deep(.markdown-body h4) {
  color: var(--color-accent);
  font-size: 1.2rem;
  margin: 1.2em 0 0.6em;
}

:deep(.markdown-body p) {
  margin: 1em 0;
  line-height: 1.8;
}

:deep(.markdown-body blockquote) {
  margin: 1em 0;
  padding: 0.5em 1em;
  color: var(--color-text-light);
  border-left: 4px solid var(--color-accent);
  background: rgba(var(--color-accent-rgb), 0.1);
}

:deep(.markdown-body ul),
:deep(.markdown-body ol) {
  margin: 1em 0;
  padding-left: 2em;
}

:deep(.markdown-body li) {
  margin: 0.5em 0;
  line-height: 1.6;
}

:deep(.markdown-body strong) {
  color: var(--color-accent);
  font-weight: 600;
}

:deep(.markdown-body em) {
  color: var(--color-text-light);
  font-style: italic;
}

:deep(.markdown-body code) {
  padding: 0.2em 0.4em;
  background: rgba(var(--color-accent-rgb), 0.1);
  border-radius: var(--radius-sm);
  font-family: var(--font-mono);
}

:deep(.markdown-body hr) {
  margin: 2em 0;
  border: none;
  border-top: 1px solid var(--color-border);
}

/* 变爻指示器样式 */
.changing-indicator {
  color: var(--color-accent);
  font-weight: bold;
  margin-left: 0.5em;
  padding: 0.2em 0.5em;
  border-radius: var(--radius-sm);
  background: rgba(var(--color-accent-rgb), 0.1);
}

.hexagram-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: var(--spacing-xl);
}

.hexagram-title {
  text-align: center;
  margin-bottom: var(--spacing-lg);
}

.diagram-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: var(--spacing-lg) 0;
}

.interpretation-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
}

.interpretation-card {
  width: 100%;
}

.card-header {
  text-align: center;
  margin-bottom: var(--spacing-lg);
}

.section {
  margin-bottom: var(--spacing-xl);
}

.section:last-child {
  margin-bottom: 0;
}

.section-title {
  color: var(--color-primary);
  margin-bottom: var(--spacing-md);
  font-size: 1.2rem;
}

.yao-text {
  margin-bottom: var(--spacing-md);
  padding: var(--spacing-md);
  border-radius: var(--radius-md);
  background-color: var(--color-background-light);
}

.yao-text.changing {
  border-left: 3px solid var(--color-accent);
}

.yao-header {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-sm);
}

.changing-mark {
  color: var(--color-accent);
  font-weight: bold;
  padding: 0.2em 0.5em;
  border-radius: var(--radius-sm);
  background: rgba(var(--color-accent-rgb), 0.1);
}

/* Loading动画样式 */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.mystical-loading {
  text-align: center;
}

.loading-circle {
  width: 60px;
  height: 60px;
  border: 3px solid var(--color-accent);
  border-top-color: transparent;
  border-radius: 50%;
  margin: 0 auto var(--spacing-lg);
  animation: spin 1s linear infinite;
}

.loading-text {
  color: var(--color-accent);
  font-family: var(--font-mystical);
  font-size: 1.2rem;
  animation: glow 2s ease-in-out infinite alternate;
}

.loading-fun-msg {
  color: var(--fh-text-muted);
  font-size: 0.85rem;
  margin-top: 12px;
  animation: fadeInOut 2.5s ease-in-out infinite;
}

@keyframes fadeInOut {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes glow {
  from {
    text-shadow: 0 0 10px var(--color-accent),
                 0 0 20px var(--color-accent),
                 0 0 30px var(--color-primary);
  }
  to {
    text-shadow: 0 0 20px var(--color-accent),
                 0 0 30px var(--color-accent),
                 0 0 40px var(--color-primary);
  }
}
.ai-response{padding:20px;background:var(--fh-input-bg);border-radius:12px;color:var(--fh-text);line-height:1.8;white-space:pre-wrap}.ai-response h1,.ai-response h2,.ai-response h3{color:var(--fh-accent-light);margin-top:16px;margin-bottom:8px}.ai-response p{margin:8px 0}.ai-response ul,.ai-response ol{padding-left:24px;margin:8px 0}

/* ============================================
   移动端独立样式 — .mobile- 前缀
   ============================================ */
.mobile-iching {
  display: flex;
  flex-direction: column;
  gap: var(--mobile-lg, 16px);
  padding: var(--mobile-md, 12px);
  padding-bottom: var(--mobile-bottom-padding);
  max-width: 480px;
  margin: 0 auto;
}

/* —— 输入区卡片 —— */
.mobile-input-card {
  background: var(--mobile-bg-card, #fff);
  border: 1px solid var(--mobile-border-color, #e5e5e5);
  border-radius: var(--mobile-radius-lg, 14px);
  padding: var(--mobile-lg, 16px);
  box-shadow: var(--mobile-shadow-card);
}

.mobile-input-header {
  display: flex;
  align-items: center;
  gap: var(--mobile-sm, 8px);
  margin-bottom: var(--mobile-md, 12px);
}

.mobile-input-icon {
  font-size: var(--mobile-font-xl, 18px);
}

.mobile-input-title {
  font-size: var(--mobile-font-lg, 16px);
  font-weight: 600;
  color: var(--mobile-text-primary, #1a1a1a);
}

.mobile-input-textarea {
  width: 100%;
  min-height: 72px;
  padding: var(--mobile-md, 12px);
  border: 1px solid var(--mobile-border-color, #e5e5e5);
  border-radius: var(--mobile-radius-md, 10px);
  font-size: var(--mobile-font-base, 14px);
  color: var(--mobile-text-primary, #1a1a1a);
  background: #fafafa;
  resize: none;
  line-height: 1.5;
  transition: border-color 0.2s;
}

.mobile-input-textarea:focus {
  outline: none;
  border-color: var(--mobile-accent, #e60023);
  background: #fff;
}

.mobile-input-textarea::placeholder {
  color: var(--mobile-text-hint, #999);
}

.mobile-start-btn {
  display: block;
  width: 100%;
  margin-top: var(--mobile-md, 12px);
  padding: 14px 0;
  border: none;
  border-radius: var(--mobile-radius-md, 10px);
  background: var(--mobile-accent, #e60023);
  color: #fff;
  font-size: var(--mobile-font-lg, 16px);
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.mobile-start-btn:active {
  opacity: 0.85;
}

.mobile-start-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* —— 投币区卡片 —— */
.mobile-casting-card {
  background: var(--mobile-bg-card, #fff);
  border: 1px solid var(--mobile-border-color, #e5e5e5);
  border-radius: var(--mobile-radius-lg, 14px);
  padding: var(--mobile-lg, 16px);
  box-shadow: var(--mobile-shadow-card);
}

.mobile-section-title {
  font-size: var(--mobile-font-lg, 16px);
  font-weight: 600;
  color: var(--mobile-text-primary, #1a1a1a);
  margin-bottom: var(--mobile-md, 12px);
}

/* —— 爻象表（简化：位置+符号+类型） —— */
.mobile-yao-display {
  border: 1px solid var(--mobile-border-color, #e5e5e5);
  border-radius: var(--mobile-radius-md, 10px);
  overflow: hidden;
  margin-bottom: var(--mobile-lg, 16px);
}

.mobile-yao-row {
  display: flex;
  align-items: center;
  padding: 10px var(--mobile-md, 12px);
  gap: var(--mobile-md, 12px);
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s;
}

.mobile-yao-row:last-child {
  border-bottom: none;
}

.mobile-yao-current {
  background: var(--mobile-accent-light, rgba(230, 0, 35, 0.08));
}

.mobile-yao-position {
  width: 44px;
  flex-shrink: 0;
  font-size: var(--mobile-font-sm, 12px);
  color: var(--mobile-text-secondary, #666);
  text-align: right;
}

.mobile-yao-symbol {
  flex: 1;
  font-family: 'Courier New', Courier, monospace;
  font-size: 14px;
  letter-spacing: 1px;
  color: var(--mobile-text-primary, #1a1a1a);
  text-align: center;
  white-space: nowrap;
}

.mobile-yao-type {
  width: 40px;
  flex-shrink: 0;
  font-size: var(--mobile-font-sm, 12px);
  color: var(--mobile-text-secondary, #666);
  text-align: center;
}

/* —— 投币大按钮 —— */
.mobile-throw-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px 0;
  border: 2px solid var(--mobile-accent, #e60023);
  border-radius: var(--mobile-radius-md, 10px);
  background: #fff;
  color: var(--mobile-accent, #e60023);
  font-size: var(--mobile-font-lg, 16px);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.mobile-throw-btn:active {
  background: var(--mobile-accent, #e60023);
  color: #fff;
}

.mobile-throw-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.mobile-throw-btn:disabled:active {
  background: #fff;
  color: var(--mobile-accent, #e60023);
}

.mobile-throw-btn-loading {
  animation: mobile-pulse 1s ease-in-out infinite;
}

@keyframes mobile-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* —— 解读区卡片 —— */
.mobile-interpretation-card {
  background: var(--mobile-bg-card, #fff);
  border: 1px solid var(--mobile-border-color, #e5e5e5);
  border-radius: var(--mobile-radius-lg, 14px);
  padding: var(--mobile-lg, 16px);
  box-shadow: var(--mobile-shadow-card);
}

/* —— 手风琴折叠面板 —— */
.mobile-accordion {
  border-bottom: 1px solid #f0f0f0;
}

.mobile-accordion:last-child {
  border-bottom: none;
}

.mobile-accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
  padding: var(--mobile-sm, 8px) 0;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s;
}

.mobile-accordion-header:active {
  background: #f8f8f8;
  border-radius: var(--mobile-radius-sm, 6px);
}

.mobile-accordion-label {
  font-size: var(--mobile-font-base, 14px);
  font-weight: 600;
  color: var(--mobile-text-primary, #1a1a1a);
}

.mobile-accordion-arrow {
  font-size: 14px;
  color: var(--mobile-text-hint, #999);
  transition: transform 0.25s ease;
  flex-shrink: 0;
  margin-left: var(--mobile-sm, 8px);
}

.mobile-accordion-arrow.expanded {
  transform: rotate(90deg);
}

.mobile-accordion-body {
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.25s ease;
  padding-bottom: var(--mobile-md, 12px);
  font-size: var(--mobile-font-base, 14px);
  color: var(--mobile-text-secondary, #666);
  line-height: 1.7;
}

/* —— 卦名区内容 —— */
.mobile-hexagram-alias {
  font-size: var(--mobile-font-sm, 12px);
  color: var(--mobile-text-hint, #999);
  margin-bottom: var(--mobile-sm, 8px);
}

.mobile-hexagram-meaning :deep(p),
.mobile-hexagram-meaning :deep(div) {
  margin: 6px 0;
}

/* —— 变卦区 —— */
.mobile-change-info {
  font-size: var(--mobile-font-sm, 12px);
  color: var(--mobile-accent, #e60023);
  margin-bottom: var(--mobile-sm, 8px);
  padding: 6px 10px;
  background: var(--mobile-accent-light, rgba(230, 0, 35, 0.08));
  border-radius: var(--mobile-radius-sm, 6px);
  display: inline-block;
}

.mobile-changed-meaning :deep(p),
.mobile-changed-meaning :deep(div) {
  margin: 6px 0;
}

/* —— 六爻详解 —— */
.mobile-yao-text-item {
  padding: var(--mobile-sm, 8px) 0;
  border-bottom: 1px solid #f5f5f5;
}

.mobile-yao-text-item:last-child {
  border-bottom: none;
}

.mobile-yao-text-changing {
  border-left: 3px solid var(--mobile-accent, #e60023);
  padding-left: var(--mobile-sm, 8px);
}

.mobile-yao-text-header {
  display: flex;
  align-items: center;
  gap: var(--mobile-sm, 8px);
  margin-bottom: 4px;
}

.mobile-yao-text-position {
  font-weight: 600;
  color: var(--mobile-accent, #e60023);
  font-size: var(--mobile-font-sm, 12px);
}

.mobile-yao-text-changing-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background: var(--mobile-accent, #e60023);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.mobile-yao-text-content :deep(p),
.mobile-yao-text-content :deep(div) {
  margin: 4px 0;
}

/* —— AI 解读内容 —— */
.mobile-ai-response {
  padding: var(--mobile-md, 12px);
  background: #fafafa;
  border-radius: var(--mobile-radius-md, 10px);
  line-height: 1.7;
  font-size: var(--mobile-font-base, 14px);
  color: var(--mobile-text-primary, #1a1a1a);
}

.mobile-ai-response :deep(h1),
.mobile-ai-response :deep(h2),
.mobile-ai-response :deep(h3) {
  color: var(--mobile-accent, #e60023);
  margin-top: 14px;
  margin-bottom: 6px;
  font-size: var(--mobile-font-lg, 16px);
}

.mobile-ai-response :deep(p) {
  margin: 8px 0;
}

.mobile-ai-response :deep(ul),
.mobile-ai-response :deep(ol) {
  padding-left: 20px;
  margin: 8px 0;
}

.mobile-ai-response :deep(li) {
  margin: 4px 0;
}

.mobile-ai-response :deep(blockquote) {
  border-left: 3px solid var(--mobile-accent, #e60023);
  padding: 4px 10px;
  margin: 8px 0;
  background: var(--mobile-accent-light, rgba(230, 0, 35, 0.05));
  border-radius: 0 var(--mobile-radius-sm, 6px) var(--mobile-radius-sm, 6px) 0;
}

.mobile-ai-response :deep(strong) {
  color: var(--mobile-accent, #e60023);
}

/* —— Loading & Empty —— */
.mobile-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--mobile-md, 12px);
  padding: var(--mobile-xl, 20px) 0;
  color: var(--mobile-text-hint, #999);
  font-size: var(--mobile-font-sm, 12px);
}

.mobile-loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e0e0e0;
  border-top-color: var(--mobile-accent, #e60023);
  border-radius: 50%;
  animation: mobile-spin 0.8s linear infinite;
}

@keyframes mobile-spin {
  to { transform: rotate(360deg); }
}

.mobile-empty {
  text-align: center;
  padding: var(--mobile-xl, 20px);
  color: var(--mobile-text-hint, #999);
  font-size: var(--mobile-font-sm, 12px);
}
</style>
